import { ThisReceiver } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs/internal/Subject';
import { EditbaseComponent } from '../editbase.component';
import { SubmenuItem } from './submenu-item';

@Injectable({
  providedIn: 'root'
})
export class SubmenuService {


  
  private prevUrl:string = "";
  public active:boolean = false;
  items: SubmenuItem[] = [];
  submenuVisibilityChange: Subject<boolean> = new Subject<boolean>();

  currentEditComponent:EditbaseComponent;


  constructor(private router: Router, public translate:TranslateService) { 
    
     router.events.subscribe((val) => {
        if(val instanceof NavigationEnd)
        {
        
         if(this.prevUrl!=val.url){
           this.hide();
           this.prevUrl = val.url;
         }
        }
    });
  }

  show(items: SubmenuItem[]) {
    this.active = true;
    this.items = items;
  }

  showRecordDetails(prefix:string, currentEditComponent:EditbaseComponent){
    this.items = null;
    let tmpItems: SubmenuItem[] = [];
    tmpItems.push(SubmenuItem.CreateNew(prefix+"/create", this.translate));
    tmpItems.push(SubmenuItem.CreateSubmit(this.translate));
    tmpItems.push(SubmenuItem.CreateDelete(this.translate));
    this.items = tmpItems;
    this.active = true;
    this.currentEditComponent = currentEditComponent;
  }

  submit(){
    this.currentEditComponent.save();
  }

  delete() {
    this.currentEditComponent.delete();
  }


  showRecordList(prefix:string){
    this.items = null;
    let tmpItems: SubmenuItem[] = [];
    tmpItems.push(SubmenuItem.CreateNew(prefix+"/create", this.translate));
    this.items = tmpItems;
    this.active = true;
  }

  hide() {
    this.active = false;
  }
}
